export default __webpack_public_path__ + "static/schicko_deckruede-43c3dadd1f2eb8fbfcf87aedb08570b3.jpg";